import React from "react";
import { createRoot } from "react-dom/client";
import { createInertiaApp } from "@inertiajs/inertia-react";
import { InertiaProgress } from "@inertiajs/progress";
// ts-disable-next-line import/no-unresolved
import { initFontAwesome } from "@/helpers";
import { AppProvider } from "@/context/AppContext";
import { AppProvider as AppProviderV2 } from "@/v2/context/AppContext";
import "../../node_modules/iframe-resizer/js/iframeResizer.contentWindow.min.js";

initFontAwesome();
InertiaProgress.init();

// Each page gets its own version's AppContext as the outermost Inertia layout, around the page's own
// layout if it has one; the same wrapper type across visits keeps its state, a v2 <-> legacy visit
// starts a fresh context. Wrapped once per module: resolve runs on every visit and the module is cached.
const wrapped = new WeakSet();
const withProvider = (Provider) => ({ default: page }) => {
    if (!wrapped.has(page)) {
        const own = page.layout;
        page.layout = Array.isArray(own)
            ? [Provider, ...own]
            : (child) => <Provider>{own ? own(child) : child}</Provider>;
        wrapped.add(page);
    }
    return page;
};

createInertiaApp({
    // versionedPage() prefixes v2/ -> resources/js/v2/Pages
    resolve: (name) => (name.startsWith("v2/")
        ? import(`./v2/Pages/${name.slice(3)}`).then(withProvider(AppProviderV2))
        : import(`./Pages/${name}`).then(withProvider(AppProvider))),
    setup({ el, App, props }) {
        const root = createRoot(el);
        root.render(
            // <React.StrictMode>
            <App {...props} />
            // </React.StrictMode>
        );
    },
});
